module.exports = __webpack_public_path__ + "static/media/SPECIAL_MEDICAL_NEEDS.78ecb09a.svg";